import { jsx as _jsx } from "react/jsx-runtime";
import { Notification, } from './notification.component';
export const CalloutNotification = (props) => (_jsx(Notification, Object.assign({}, props, { variant: 'callout', closeable: false })));
//# sourceMappingURL=notification_callout.component.js.map